import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'group inline-flex items-center justify-center gap-2 whitespace-nowrap text-xs/6 font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-primary text-black border border-primary hover:bg-primary/70 [&_svg]:size-4',
        destructive: 'bg-white text-destructive border border-outline hover:bg-destructive/30 [&_svg]:size-4',
        outline: 'border border-outline bg-white text-black shadow-sm hover:bg-outline/80 [&_svg]:size-4',
        secondary: 'border border-transparent bg-seapoint-gray-medium hover:bg-seapoint-gray-medium/30 [&_svg]:size-4',
        ghost: '',
        link: 'text-primary underline-offset-4 hover:underline [&_svg]:size-4',
      },
      rounded: {
        true: 'rounded-3xl',
        false: 'rounded-none',
      },
      size: {
        default: 'px-4 py-2 text-xs leading-6',
        lg: 'px-6 py-3 text-base leading-6',
        icon: 'h-9 w-9',
        iconLarge: 'h-12 w-12',
        none: '',
      },
    },
    defaultVariants: {
      variant: 'default',
      rounded: true,
      size: 'default',
    },
  },
);
